// API endpoints for the BHA application
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
export const API_URL = API_BASE_URL; // Alias for backwards compatibility

export const AUTH_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  ADMIN_LOGIN: `${API_BASE_URL}/auth/admin-login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  REFRESH: `${API_BASE_URL}/auth/refresh`,
  WHOAMI: `${API_BASE_URL}/auth/whoami`,
  PROFILE: `${API_BASE_URL}/auth/profile`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  RESET_PASSWORD_TOKEN: `${API_BASE_URL}/auth/reset-password-token`,
  VERIFY_PASSWORD_TOKEN: `${API_BASE_URL}/auth/password-token-verify`,
  FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
  CLIENT_LOGIN: `${API_BASE_URL}/auth/client/login`,
  CLIENT_REGISTER: `${API_BASE_URL}/auth/client/register`,
  AGENT_LOGIN: `${API_BASE_URL}/auth/agent/login`,
};

export const USER_ENDPOINTS = {
  UPDATE_PROFILE: `${API_BASE_URL}/user/update-profile`,
  SET_FAVORITE: `${API_BASE_URL}/user/favorite`,
  GET_FAVORITE: `${API_BASE_URL}/user/favorite`,
  GET_LENDED_HOMES: `${API_BASE_URL}/user/lended-homes`,
  SET_TERMS: `${API_BASE_URL}/user/terms`,
};

export const INVESTOR_PROFILE_ENDPOINTS = {
  SAVE_INVESTMENT_PREFERENCES: `${API_BASE_URL}/investor-profile/investment-preferences`,
  SAVE_LOCATION_PREFERENCES: `${API_BASE_URL}/investor-profile/location-preferences`,
  SAVE_FINANCIAL_INFORMATION: `${API_BASE_URL}/investor-profile/financial-information`,
  GET_PROFILE: `${API_BASE_URL}/investor-profile/profile`,
};

export const LISTING_ENDPOINTS = {
  PROP_GPT_SEARCH: `${API_BASE_URL}/listing/prop-gpt-search`,
};

export const SCREENING_ENDPOINTS = {
  SUBMIT_BUS_DATA: `${API_BASE_URL}/screening/submit`, // Fixed to match backend route
  GET_BUS_DATA: `${API_BASE_URL}/screening/bus-data`,
  GET_SCREENING_HISTORY: `${API_BASE_URL}/screening/history`,
};

export const INBOX_ENDPOINTS = {
  GET_CONVERSATIONS: `${API_BASE_URL}/inbox/conversations`,
  GET_CONVERSATION: (id) => `${API_BASE_URL}/inbox/conversations/${id}`,
  GET_MESSAGES: (id) => `${API_BASE_URL}/inbox/conversations/${id}/messages`,
  SEND_MESSAGE: (id) => `${API_BASE_URL}/inbox/conversations/${id}/messages`,
  MARK_AS_READ: (id) => `${API_BASE_URL}/inbox/conversations/${id}/read`,
  ARCHIVE_CONVERSATION: (id) => `${API_BASE_URL}/inbox/conversations/${id}/archive`,
  GET_UNREAD_COUNT: `${API_BASE_URL}/inbox/unread-count`,
  START_CONVERSATION: `${API_BASE_URL}/inbox/conversations`,
  WEBSOCKET: `${API_BASE_URL.replace('http', 'ws')}/inbox/ws`,
};

// Structured api object for convenient imports
export const api = {
  auth: {
    signIn: AUTH_ENDPOINTS.LOGIN,
    signUp: AUTH_ENDPOINTS.REGISTER,
    clientSignIn: AUTH_ENDPOINTS.CLIENT_LOGIN,
    clientSignUp: AUTH_ENDPOINTS.CLIENT_REGISTER,
    agentSignIn: AUTH_ENDPOINTS.AGENT_LOGIN,
    whoami: AUTH_ENDPOINTS.WHOAMI,
    getProfile: AUTH_ENDPOINTS.PROFILE,
    updateProfile: AUTH_ENDPOINTS.PROFILE,
    logout: AUTH_ENDPOINTS.LOGOUT,
    refresh: AUTH_ENDPOINTS.REFRESH,
  },
  user: {
    updateProfile: USER_ENDPOINTS.UPDATE_PROFILE,
    setFavorite: USER_ENDPOINTS.SET_FAVORITE,
    getFavorite: USER_ENDPOINTS.GET_FAVORITE,
    getLendedHomes: USER_ENDPOINTS.GET_LENDED_HOMES,
    setTerms: USER_ENDPOINTS.SET_TERMS,
  },
  investorProfile: {
    saveInvestmentPreferences: INVESTOR_PROFILE_ENDPOINTS.SAVE_INVESTMENT_PREFERENCES,
    saveLocationPreferences: INVESTOR_PROFILE_ENDPOINTS.SAVE_LOCATION_PREFERENCES,
    saveFinancialInformation: INVESTOR_PROFILE_ENDPOINTS.SAVE_FINANCIAL_INFORMATION,
    getProfile: INVESTOR_PROFILE_ENDPOINTS.GET_PROFILE,
  },
  listing: {
    propGPTSearch: LISTING_ENDPOINTS.PROP_GPT_SEARCH,
  },
  screening: {
    submitBusData: SCREENING_ENDPOINTS.SUBMIT_BUS_DATA,
    getBusData: SCREENING_ENDPOINTS.GET_BUS_DATA,
    getScreeningHistory: SCREENING_ENDPOINTS.GET_SCREENING_HISTORY,
  },
  inbox: {
    getConversations: INBOX_ENDPOINTS.GET_CONVERSATIONS,
    getConversation: INBOX_ENDPOINTS.GET_CONVERSATION,
    getMessages: INBOX_ENDPOINTS.GET_MESSAGES,
    sendMessage: INBOX_ENDPOINTS.SEND_MESSAGE,
    markAsRead: INBOX_ENDPOINTS.MARK_AS_READ,
    archiveConversation: INBOX_ENDPOINTS.ARCHIVE_CONVERSATION,
    getUnreadCount: INBOX_ENDPOINTS.GET_UNREAD_COUNT,
    startConversation: INBOX_ENDPOINTS.START_CONVERSATION,
    websocket: INBOX_ENDPOINTS.WEBSOCKET,
  },
};

export default {
  AUTH_ENDPOINTS,
  USER_ENDPOINTS,
  INVESTOR_PROFILE_ENDPOINTS,
  LISTING_ENDPOINTS,
  SCREENING_ENDPOINTS,
  INBOX_ENDPOINTS,
  api,
};
